/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BuyerAgentCommissionSource } from './BuyerAgentCommissionSource';
import {
    BuyerAgentCommissionSourceFromJSON,
    BuyerAgentCommissionSourceFromJSONTyped,
    BuyerAgentCommissionSourceToJSON,
} from './BuyerAgentCommissionSource';

/**
 * 
 * @export
 * @interface ClientProposedTermsRequestBuyerAgentCommissionSource
 */
export interface ClientProposedTermsRequestBuyerAgentCommissionSource {
}

/**
 * Check if a given object implements the ClientProposedTermsRequestBuyerAgentCommissionSource interface.
 */
export function instanceOfClientProposedTermsRequestBuyerAgentCommissionSource(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ClientProposedTermsRequestBuyerAgentCommissionSourceFromJSON(json: any): ClientProposedTermsRequestBuyerAgentCommissionSource {
    return ClientProposedTermsRequestBuyerAgentCommissionSourceFromJSONTyped(json, false);
}

export function ClientProposedTermsRequestBuyerAgentCommissionSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientProposedTermsRequestBuyerAgentCommissionSource {
    return json;
}

export function ClientProposedTermsRequestBuyerAgentCommissionSourceToJSON(value?: ClientProposedTermsRequestBuyerAgentCommissionSource | null): any {
    return value;
}

